import { useEffect, useState } from "react";
import { api, useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { AlertTriangle, Phone, LogOut } from "lucide-react";

export function MahasiswaStatusGate() {
  const { user, logout } = useAuth();
  const [nonaktif, setNonaktif] = useState(false);

  useEffect(() => {
    if (user?.role !== "mahasiswa") return;
    api.get("/mahasiswa/me").then((r) => setNonaktif(r.data.status === "Nonaktif")).catch(() => {});
  }, [user]);

  if (user?.role !== "mahasiswa" || !nonaktif) return null;
  return (
    <div className="fixed inset-0 z-[100] bg-[#002147]/95 backdrop-blur-sm flex items-center justify-center p-6" data-testid="mahasiswa-nonaktif-overlay">
      <div className="bg-white rounded-2xl max-w-md w-full p-8 text-center space-y-4 shadow-2xl">
        <div className="h-16 w-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto"><AlertTriangle className="h-8 w-8 text-amber-600" /></div>
        <h2 className="font-display font-extrabold text-2xl text-[#0F172A]">Akun Nonaktif</h2>
        <p className="text-slate-600 leading-relaxed">Masa tugas KKN/PPL/Magang Anda telah berakhir sehingga akun dinonaktifkan secara otomatis. Untuk informasi lebih lanjut, silakan <span className="font-bold">hubungi Operator</span> sekolah.</p>
        <div className="flex items-center justify-center gap-2 text-sm font-semibold text-[#002147] bg-slate-100 rounded-lg py-2.5"><Phone className="h-4 w-4" /> Hubungi Operator Sekolah</div>
        <Button variant="outline" className="w-full gap-2" onClick={logout} data-testid="mahasiswa-nonaktif-logout"><LogOut className="h-4 w-4" /> Keluar</Button>
      </div>
    </div>
  );
}
